"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toOption = exports.QUERY_FORMAT_OPTIONS = exports.EditorMode = exports.QueryFormat = void 0;
const data_1 = require("@grafana/data");
// Match the Enums Expected in SqlUtil and SqlDS
// https://github.com/grafana/grafana-plugin-sdk-go/blob/main/data/sqlutil/query.go#L18-L29
var QueryFormat;
(function (QueryFormat) {
    QueryFormat[QueryFormat["Timeseries"] = 0] = "Timeseries";
    QueryFormat[QueryFormat["Table"] = 1] = "Table";
    QueryFormat[QueryFormat["Logs"] = 2] = "Logs";
    QueryFormat[QueryFormat["Trace"] = 3] = "Trace";
    QueryFormat[QueryFormat["OptionMulti"] = 4] = "OptionMulti";
})(QueryFormat = exports.QueryFormat || (exports.QueryFormat = {}));
var EditorMode;
(function (EditorMode) {
    EditorMode["Builder"] = "builder";
    EditorMode["Code"] = "code";
})(EditorMode = exports.EditorMode || (exports.EditorMode = {}));
exports.QUERY_FORMAT_OPTIONS = [
    { label: 'Time series', value: QueryFormat.Timeseries },
    { label: 'Table', value: QueryFormat.Table },
];
const backWardToOption = (value) => ({ label: value, value });
exports.toOption = data_1.toOption !== null && data_1.toOption !== void 0 ? data_1.toOption : backWardToOption;
//# sourceMappingURL=types.js.map